import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { roleLabel } from '../utils/auth';
const API_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_LOCAL_API_URL;
export default function RegUser({ userRole = 0 }) {
  const admin = [1,2].includes(userRole);
  const [associations, setAssociations] = useState([]);
  const [form, setForm] = useState({ name: '', email: '', password: '', associationId: '', role: 3 });
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => { axios.get(`${API_URL}/associations`).then(r => setAssociations(r.data.associations)).catch(() => setError('Föreningslistan kunde inte hämtas.')); }, []);
  async function submit(e) {
    e.preventDefault(); setError(''); setMessage('');
    if (form.password !== confirm) { setError('Lösenorden matchar inte.'); return; }
    setBusy(true);
    try {
      const { role, ...data } = form;
      const r = await axios.post(`${API_URL}${admin ? '/users/add-user' : '/auth/register'}`, admin ? form : data,
        admin ? { headers: { token: localStorage.getItem('token') } } : {});
      setMessage(r.data.message); setForm({ name: '', email: '', password: '', associationId: '', role: 3 }); setConfirm('');
    } catch (e) { setError(e.response?.data?.message || 'Registreringen misslyckades.'); }
    finally { setBusy(false); }
  }
  return <main className="mx-auto max-w-xl p-4"><div className="theme-card">
    <h1 className="text-xl font-bold">{admin ? 'Lägg till användare' : 'Registrera konto'}</h1>
    {!admin && <p className="my-3">Välj din förening. Alla nya konton behöver verifierad e-post och godkännande av Site admin eller Admin, även föreningsadministratörer.</p>}
    <form onSubmit={submit} className="flex flex-col gap-3 mt-4">
      {['name','email','password'].map(field => <label key={field}>{({name:'Namn',email:'E-postadress',password:'Lösenord'})[field]}
        <input className="theme-input w-full" type={field === 'name' ? 'text' : field} required minLength={field === 'password' ? 8 : undefined} maxLength={field === 'name' ? 150 : field === 'email' ? 254 : 72} autoComplete={field === 'password' ? 'new-password' : field} value={form[field]} onChange={e => setForm({...form,[field]:e.target.value})}/></label>)}
      <label>Bekräfta lösenord<input className="theme-input w-full" type="password" required autoComplete="new-password" value={confirm} onChange={e => setConfirm(e.target.value)}/></label>
      <label>Förening<select className="theme-input w-full" required={!admin || ![1,2].includes(Number(form.role))} value={form.associationId} onChange={e => setForm({...form,associationId:e.target.value})}>
        <option value="">Välj förening</option>{associations.map(a => <option key={a._id} value={a._id}>{a.name}</option>)}
      </select></label>
      {admin && <label>Roll<select className="theme-input w-full" value={form.role} onChange={e => setForm({...form,role:Number(e.target.value)})}>{(userRole === 1 ? [3,5,4,2,1] : [3]).map(r => <option key={r} value={r}>{roleLabel(r)}</option>)}</select></label>}
      <button className="theme-button-primary" disabled={busy}>{busy ? 'Sparar…' : admin ? 'Skapa konto' : 'Registrera'}</button>
    </form>
    {error && <p role="alert" className="theme-alert-error mt-3">{error}</p>}
    {message && <p role="status" className="theme-alert-success mt-3">{message}</p>}
    <Link className="block mt-4 text-sky-700" to={admin ? '/user-management' : '/login'}>Tillbaka</Link>
  </div></main>;
}
